<div class="empty-right" :class="[theme, isMobileSize ? 'isMobile' : '', showMap ? 'show-map' : '']">
    <site-img
        :src="emptyImg"
    ></site-img>
    <div class="des">
        {{ $t('md-search-result.oopsThisAreaCurrently') }}
    </div>
    <ul v-if="!isFeatureAreaPage" class="empty-option-list" :class="[theme, isMobileSize ? 'isMobile' : '']">
        <li class="option-item" :class="{'option-item-disabled': isDisabledEmptyZoomOut}" v-if="showMap" @click="handlerZoomOut">{{ $t('md-search-result.zoomOut') }}</li>
        <li class="option-item" v-if="showMap" @click="clearPolygonBoundray">{{ $t('md-search-result.clearMapBoundary') }}</li>
        <li class="option-item">
            <span class="reset-filter" @click="resetSearch" role="button">{{ $t('md-search-result.resetFilter') }}</span>
            <span class="reset-tip">{{ $t('md-search-result.resetTip') }}</span>
        </li>
    </ul>
    <ul v-if="!isFeatureAreaPage" class="empty-search-conditions" :class="[theme, isMobileSize ? 'isMobile' : 'isPc', showMap ? 'show-map' : 'hide-map']">
        <li class="condition-item-tag" v-for="item in filteredTagList" :key="item.label" @click.stop>
            <span class="tag-name">{{ item.label }}</span>
            <span class="iconfont icon-close tag-close" @click="removeTag(item)" role="button"></span>
        </li>
    </ul>
</div>
